import { forwardRef, createElement } from 'react';

function IconRestore(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M18 9.25a.75.75 0 01.743.648l.007.102v8.25a3.75 3.75 0 01-3.55 3.745L15 22h-5a3.75 3.75 0 01-3.745-3.55l-.005-.2V10a.75.75 0 01.648-.743L7 9.25h11zm-.75 1.5h-9.5v7.5a2.25 2.25 0 001.938 2.229l.158.016.154.005h5a2.25 2.25 0 002.245-2.096l.005-.154v-7.5zm-6.75 1.5a.75.75 0 01.743.648l.007.102v5.25a.75.75 0 01-1.493.102l-.007-.102V13a.75.75 0 01.75-.75zm4 0a.75.75 0 01.743.648l.007.102v5.25a.75.75 0 01-1.493.102l-.007-.102V13a.75.75 0 01.75-.75zm2.372-9.849a3.847 3.847 0 012.03 4.45l2.668 1.302a.75.75 0 01-.563 1.386l-.094-.038L9.086 3.732a.75.75 0 01.563-1.386l.094.038 2.373 1.157a3.847 3.847 0 014.756-1.14zM3 4.25a.75.75 0 01.743.648L3.75 5v.63c2.434-1.684 5.714-1.245 7.542 1.11a.75.75 0 11-1.185.919C8.819 6 6.547 5.647 4.777 6.749l.723.001a.75.75 0 01.743.648l.007.102a.75.75 0 01-.648.743L5.5 8.25H3a.75.75 0 01-.743-.648L2.25 7.5V5A.75.75 0 013 4.25zm10.507-.031l4.005 1.953a2.347 2.347 0 00-4.005-1.953z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Restore = /*#__PURE__*/forwardRef(IconRestore);

export default Restore;
//# sourceMappingURL=Restore.js.map
